import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TaskService } from '../services/task.service';
import { WorkitemAction } from '../../entity/workitem-action';
import { CompleteContext, AssigneeInfo, CompleteResponse } from '../../entity';
import { NotifyService } from '@farris/ui-notify';
import { TaskSignaddComponent } from '../components/task-signadd/task-signadd.component';
import { DialogComponent } from '@farris/ui-dialog';
import { ActionEntity } from '../../entity/action-entity';
import { from, of, Observable } from 'rxjs';
import { I18nService } from '../services/i18n.service';
import { NextNode } from '../../entity/destination-nodes';
import { FlowNodeInfo } from '../../entity/excution-response';

declare const System: any;
@Component({
  selector: 'wf-workitem-handle',
  templateUrl: './wf-workitem-handle.component.html',
  styleUrls: ['./wf-workitem-handle.component.css']
})
export class WfWorkitemHandleComponent implements OnInit {
  private inWorkitemId: string;
  private taskActions: WorkitemAction[];
  completeContext = new CompleteContext();
  assigneeInfos: AssigneeInfo[];
  transferContext: {
    workItemId: string,
    comment: string
  };
  destActivities: { id: string, name: string }[];
  // 加签征询上下文参数
  addSignContext: {
    workItemId: string,
    action: 'AddSignFront' | 'AddSignBehind'
  };
  needAddSign: boolean; // 是否需要加签
  selectAddSignees: string; // 加签选中人
  displayPlaceholder: string = "请选择";//跳转的默认显示节点
  hasDefaultBranch = true;
  @ViewChild(TaskSignaddComponent)
  addSignCmp: TaskSignaddComponent;
  @ViewChild('commentModal')
  commentModal: DialogComponent;
  /**
   * 任务Id
   */
  @Input()
  set workitemId(workitemId: string) {
    this.inWorkitemId = (workitemId && workitemId.trim());
    if (this.inWorkitemId) {
      this.refreshActions();
    }
  }
  get workitemId() {
    return this.inWorkitemId;
  }

  /**
   * 任务办理动作列表
   */
  @Output()
  actions = new EventEmitter<WorkitemAction[]>();

  /**
   * 任务办理完成事件
   */
  @Output()
  completed = new EventEmitter<boolean>();

  // 当前选中动作和动作实现
  preFuncList: any[] = [];
  webCptFunc: any;
  postFuncList: any[] = [];

  // 弹框高度设置
  height = 420;

  actionsTitle = {
    pass: '',
    back: '',
    refuse: '',
    more: '',
    viewLog: '',
    viewFlowChart: '',
    viewBizlog: ''
  };

  constructor(
    private taskSvc: TaskService,
    private notify: NotifyService,
    private i18nService: I18nService,
  ) {
    const titles = this.i18nService.getValue('static.taskActions');
    Object.keys(this.actionsTitle).forEach(key => {
      this.actionsTitle[key] = titles[key];
    });
  }

  ngOnInit() {
  }

  /**
   * 刷新动作列表
   */
  private refreshActions() {
    this.taskSvc.getWorkItemActions(this.inWorkitemId).subscribe((re: any) => {
      // 临时方案：oData不支持自定义function $expand展开，临时序列化处理
      this.taskActions = re.map(action => {
        action.parameters = JSON.parse(action.parameters);
        return action;
      });
      this.taskActions = this.taskActions.filter(a =>
        a.code !== 'ViewBizLog'
        && a.code !== 'ViewFlowChart'
        && a.code !== 'ViewExecuteForm');

      this.actions.emit(this.taskActions);
    }, error => {
      this.showError(error);
    });
  }

  /**
   * 动作完成后事件
   * @param result 事件结果
   */
  private completedEvt(result: boolean = true) {
    if (result) {
      this.refreshActions();
    }
    this.completed.emit(result);
  }

  /**
   * 完成审批任务
   * @param actionCode 任务办理动作编号
   * @param comment? 办理意见
   */
  complete(actionCode: string, comment?: string) {
    switch (actionCode) {
      case 'AssignUser': { // 指派
        this.assignee(this.inWorkitemId);
        break;
      }
      case 'Claim': // 领用
        this.taskSvc.claim(this.inWorkitemId).subscribe(r => {
          this.notify.success(this.i18nService.getValue('cueWords.successClaim'));
          this.refreshActions();
          this.completed.emit(false);
        }, error => {
          this.showError(error);
        });
        break;
      case 'Unclaim': // 取消领用
        this.taskSvc.unClaim(this.inWorkitemId).subscribe(r => {
          this.notify.success(this.i18nService.getValue('cueWords.successUnClaim'));
          this.refreshActions();
          this.completed.emit(false);
        }, error => {
          this.showError(error);
        });
        break;
      case 'Retrieve': // 取回
        this.taskSvc.retrieve({ workItemId: this.inWorkitemId, comment }).subscribe(r => {
          this.notify.success(this.i18nService.getValue('cueWords.successRetrieve'));
          this.completedEvt();
        },error => {
          this.showError(error);
        });
        break;
      case 'Transfer': { // 移交
        this.transferContext = {
          workItemId: this.inWorkitemId,
          comment
        };
        break;
      }
      case 'AddSignFront': // 征询
        this.addSignContext = {
          workItemId: this.inWorkitemId,
          action: 'AddSignFront'
        };
        break;
      default:
        this.executeTask(actionCode, comment);
    }
  }

  refreshList(sucess: boolean) {
    this.completedEvt(sucess);
  }
  // 弹出加签帮助
  runAddSign() {
    this.addSignContext = {
      workItemId: this.inWorkitemId,
      action: 'AddSignBehind'
    };
  }
  // 加签完成
  addSignComplete(sucess: boolean) {

    if (this.addSignContext.action === 'AddSignFront') {
      this.refreshList(sucess);
    } else {
      this.completeContext.signAssignees = this.addSignCmp.selectedUsers.map(user => user.ID);
      this.selectAddSignees = this.addSignCmp.selectedUsers.map(user => user.Name).join(',');
    }
  }

  // 审批确认
  handleOk() {
    if(!this.completeContext.comment) {
      this.notify.info("请输入审批意见");
      return;
    }
    if(!this.hasDefaultBranch && this.completeContext.destinationActivityId.length <= 0) {//没有默认分支并且用户没选择跳转节点，不允许提交
      this.notify.info("请选择目标节点");
      return;
    }
    this.taskSvc.excuteTask(this.inWorkitemId, this.completeContext).subscribe(
      (cr: CompleteResponse) => {
        this.commentModal.close();
        // 完成工作项后，检查是否需要执行后事件
        this.excutePostEvent();
        if (this.completeContext.conclusionValue === 'Pass') {
          this.notify.success(this.i18nService.getValue('cueWords.successPass'));
        } else if (this.completeContext.conclusionValue === 'Back') {
          this.notify.success(this.i18nService.getValue('cueWords.successBack'));
        } else if (this.completeContext.conclusionValue === 'Refuse') {
          this.notify.success(this.i18nService.getValue('cueWords.successRefuse'));
        } else {
          this.notify.success(this.i18nService.getValue('cueWords.success'));
        }
        if (cr.needInteraction) {
          this.refreshActions();//通过后弹出指派 add by fpf
          this.assigneeInfos = [cr.nextFlowNodes[0].assigneeInfo];
        } else {
          this.completedEvt();
        }
      }, error => {
        this.showError(error);
      }); 
  }
  // 取消操作
  handleCancel() {
    this.completeContext = new CompleteContext();
    this.commentModal.close();
  }
  // 指派操作
  private assignee(workItemId: string) {
    this.taskSvc.getAssigneeInfo(workItemId).subscribe((info: FlowNodeInfo) => {
      info.assigneeInfo.workItemId = workItemId;//兼容处理，此处返回的workitemid为null
      this.assigneeInfos = [info.assigneeInfo];
    }, error => {
      this.showError(error);
    });
  }
  // 重新初始化当前参数
  private initState() {
    this.selectAddSignees = '';
    this.destActivities = null;
    this.needAddSign = false;
  }

  private executeTask(actionCode: string, opinion?: string) {
    this.initState();
    this.completeContext = {
      workItemId: this.inWorkitemId,
      conclusionValue: actionCode,
      comment: '',
      signAssignees: [], // 加签人员
      destinationActivityId: ''// 目标节点
    };
    this.completeContext.comment = actionCode === 'Pass' ? this.actionsTitle.pass : '';
    if (opinion) {
      this.completeContext.comment = opinion;
    }
    const action = this.taskActions.find(a => a.code === actionCode);
    this.taskSvc.getActionEntity(this.workitemId, actionCode).subscribe((act: ActionEntity) => {

      if (!act) {// 审批动作已删除，走完成工作项  TODO: 非完成工作项动作如何处理？
        this.showExcuteModal(action);
      } else {
        from(this.excuteAction(act)).subscribe(() => {
          if (!act.webComponent) {
            this.showExcuteModal(action);
          }
        });
      }
    }, error => {
      this.showError(error);
    });
  }
  
  /**
   * 加签，跳转情况
   * @param action 动作
   */
  private showExcuteModal(action: WorkitemAction) {
    // 动作参数按照
    if (action && action.parameters) {
      // 跳转、驳回场景
      if (action.parameters.SelectTargetAble === 'True' || action.parameters.SelectTargetAble === 'true') {
        // this.taskSvc.getDestinationScope(this.inWorkitemId, action.code).subscribe((re: { id: string, name: string }[]) => {
        //   this.destActivities = re;
        // });
        this.getDestinationNodes(this.inWorkitemId, action.code);
      }
      // 需要加签
      if (action.parameters.AddSignBehindAble === 'True' || action.parameters.AddSignBehindAble === 'true') {
        this.needAddSign = true;
      }
    }
    this.commentModal.show();
  }

  private getDestinationNodes(workItemId: string, actionCode: string) {
    var nextNodes: NextNode[] = [];
    this.taskSvc.getDestinationScope(workItemId, actionCode).subscribe((re: NextNode[]) => {
      nextNodes = re;
      const des = re.map(a => a.nodeInfoList);
      let list =[];
      des.forEach(i => {
        list = list.concat(i);
      });
      this.destActivities = list.map(i => ({id:i.activityDefinitionId, name:i.activityDefinitionName}));
      this.hasDefaultBranch = this.hasDefaultBranchFunc(nextNodes);
    }, error => {
      this.showError(error);
    });
  }

  /**
   * 跳转，返回的数据是否有默认分支
   * 如果返回的没有默认节点，跳转节点又没选的话，不允许提交
   * @param nextNodes 
   */
  private hasDefaultBranchFunc(nextNodes: NextNode[]) {
    for(let i = 0; i < nextNodes.length; i++) {
      if(nextNodes[i].defaultBranch) {
        this.displayPlaceholder = nextNodes[i].nodeInfoList[0].activityDefinitionName;
        return true;
      }
    }
    return false;
  }
  private async excuteAction(act: ActionEntity) {
    await this.getActionWebEventsFunc(act);
    if (this.preFuncList && this.preFuncList.length > 0) {
      for (let i = 0; i < this.preFuncList.length; i++) {
        this.preFuncList.filter(item => item.index === i)[0].func();
      }
    }
    if (this.webCptFunc) {
      this.webCptFunc();
    }
  }
  private excutePostEvent() {
    if (this.postFuncList && this.postFuncList.length > 0) {
      for (let i = 0; i < this.postFuncList.length; i++) {
        this.postFuncList.filter(item => item.index === i)[0].func();
      }
    }
  }
  /**
   * 获取动作的前后事件和实现方法
   * @param act 动作
   */
  private async getActionWebEventsFunc(act: ActionEntity) {
    this.preFuncList = [];
    this.webCptFunc = null;
    this.postFuncList = [];
    const reqMap = [];
    let preIndex = 0;
    let postIndex = 0;
    if (act.preEvent && act.preEvent.length > 0) {
      for (const e of act.preEvent) {
        const pre = {
          event: 'pre',
          index: preIndex++,
          funcName: e.component.split('#')[1],
          req: System.import(e.component.split('#')[0])
        };
        reqMap.push(pre);
      }
    }
    if (act.webComponent) {
      const cpt = {
        event: 'cpt',
        index: 0,
        funcName: act.webComponent.split('#')[1],
        req: System.import(act.webComponent.split('#')[0])
      };
      reqMap.push(cpt);
    }
    if (act.postEvent && act.postEvent.length > 0) {
      for (const a of act.postEvent) {
        const post = {
          event: 'post',
          index: postIndex++,
          funcName: a.component.split('#')[1],
          req: System.import(a.component.split('#')[0])
        };
        reqMap.push(post);
      }
    }
    for (const r of reqMap) {
      const m = await r.req;
      if (r.event === 'pre') {
        this.preFuncList.push({
          index: r.index,
          func: m.default[r.funcName]
        });
      } else if (r.event === 'post') {
        this.postFuncList.push({
          index: r.index,
          func: m.default[r.funcName]
        });
      } else {
        this.webCptFunc = m.default[r.funcName];
      }
    }
  }

  /**
   * 显示报错信息
   */
  private showError(error: any) {
    if(error && error.error && error.error.Message) {
      this.notify.error(error.error.Message);
    } else {
      this.notify.error(error);
    }
  }
}
